import styled from "styled-components";
// 위쪽 머리칸(div·subdiv) + 설명(text) + 번호 목록(numberedContents) 카드
const HeadedBoxCol = ({ div, subdiv, subHeader, text, numberedContents }) => {
  return (
    <Div>
      <div className="head">
        <div>{div}</div>
        <div>{subdiv}</div>
      </div>
      {subHeader && <SubHeaderDiv>{subHeader}</SubHeaderDiv>}
      {text && <TextDiv>{text}</TextDiv>}
      {numberedContents && (
        <div className="list">
          <ol>
            {numberedContents?.map((x, idx) => (
              <li key={idx}>{x}</li>
            ))}
          </ol>
        </div>
      )}
    </Div>
  );
};
export default HeadedBoxCol;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.radius};
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  overflow: hidden;
  & > .head {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    padding: 1.25rem 1rem;
    background: linear-gradient(160deg, ${({ theme }) => theme.colors.dark}, ${({ theme }) => theme.colors.ink});
    & > div:first-child {
      font-weight: 700;
      color: white;
      font-size: 1.3rem;
    }
    & > div:nth-child(2) {
      font-size: 0.9rem;
      color: ${({ theme }) => theme.colors.foreground.highlightinverted};
    }
  }
  & > .list {
    padding: 0 1.5rem 1.5rem;
    & > ol {
      list-style: none;
      counter-reset: item;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 0.6rem;
      & > li {
        counter-increment: item;
        display: flex;
        gap: 0.75rem;
        line-height: 1.6;
        color: ${({ theme }) => theme.colors.monotone.dark};
        &:before {
          content: counter(item);
          flex: 0 0 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: ${({ theme }) => theme.colors.accentSoft};
          color: ${({ theme }) => theme.colors.accent};
          font-size: 0.8rem;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 0.1rem;
        }
      }
    }
  }
`;
const SubHeaderDiv = styled.div`
  padding: 1.25rem 1.5rem 0;
  color: ${({ theme }) => theme.colors.dark};
  font-size: 1.1rem;
  font-weight: 600;
`;

const TextDiv = styled.div`
  margin: 1.25rem 1.5rem;
  padding: 1rem 1.25rem;
  border-radius: 0.6rem;
  background-color: ${({ theme }) => theme.colors.monotone.extralight};
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.7;
`;
